import "antd/dist/antd.css";
import "../assests/style.css";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import DashboardNewService from "../../services/DashboardNew/DashboardNewService";
import { Col, Row } from "antd";
import DashboardAnetar from "./DashboardAnetar";



const DashboardNew = () => {
    const token = useSelector((state) => state.Member.token);
    const [dashboardData, setDashboardData] = useState({});
    const [loading, setLoading] = useState(false);

    
    useEffect(() => {
        setLoading(true);
        DashboardNewService.getDashboardData(token)
            .then((response) => {
                let percentage = 0;
                percentage =
                    response.data.points.current_month !== 0 &&
                    response.data.points.last_month !== 0 &&
                    response.data.points.current_month / response.data.points.last_month;

                const responseData = {
                    ...response.data,
                    percentage:
                        percentage < 1
                            ? parseFloat(percentage * 100).toFixed(1)
                            : parseFloat(percentage * 100 - 100).toFixed(1),
                };

                setDashboardData(responseData);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token]);


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>
                <DashboardAnetar 
                    dashboardData={dashboardData} 
                    loading={loading} 
                />
            </Col>
        </Row>
    );
};


export default DashboardNew;